/**
 * Helpers for Dispatch run-queue pointer-drag ownership (77R1 / 78R2).
 * Only the initiating pointerId may move, complete, or cancel a drag.
 * Release target must be a live same-run row under the pointer — never a stale hover id.
 */

export function isActivePointer(
  activePointerId: number | null,
  eventPointerId: number,
): boolean {
  return activePointerId != null && eventPointerId === activePointerId;
}

/**
 * Resolve a drop trip id from the element under the pointer.
 * Returns null when outside the queue, on another vehicle run, or without a trip id.
 * Callers must not fall back to a previously hovered drop target.
 */
export function tripIdFromPointInRun(
  underPoint: Element | null,
  runId: string,
): string | null {
  const row = underPoint?.closest?.('.run-queue-item') as HTMLElement | null;
  if (!row) return null;
  const vehicle = row.closest('.run-queue-vehicle') as HTMLElement | null;
  if (!vehicle || vehicle.getAttribute('data-run-id') !== runId) return null;
  const tripId = row.dataset?.tripId?.trim();
  return tripId || null;
}
